export default {
  id: 'healthHistory/FAMILY_HISTORY/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.familyHistory',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.familyHistory',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
